const english = [
  "Password",
  "Login",
  "Email",
  "You are not connected to any network",
  "Required field",
  "Invalid credentials",
  "Multiple session error",
  "Unknown error",
  "Multiple open sessions have been detected",
  "Your signature is required to continue. Please sign in the box!",
  "Signature Required",
  "Save",
  "Clear",
  "The signature was rejected by the administrator. Please enter your signature again.",
  "The signature is in the validation process. try again later.",
  "Inspection Date",
  "Inspection Time",
  "Odometer",
  "Remarks",
  "Inspection Date Required",
  "Inspection Time Required",
  "Odometer required",
  "Truck number required",
  "Trailer number required",
  "Please select a mechanic",
  "Error select an option",
  "Trip",
  "Tonnage",
  "Check in time",
  "Departure time",
  "Upload Ticket",
  "Has no trips",
  "Must enter Time in first!",
  "Warning",
  "Report wrong destination?",
  "View Ticket",
  "Enter a Mileage equal to or greater than income",
  "Departure",
  "Invalid ticket, does not comply with the rules",
  "Ticket: Only uppercase characters numbers and hyphen are allowed",
  "Tons: Only integers or numbers with two decimals are allowed",
  "Tons: Must be greater than 0",
  "Error",
  "Tons: Must be less than or equal to 40",
  "Air Compressor",
  "Air Lines",
  "Battery",
  "Belst and Hoses",
  "Body",
  "Brake Accessories",
  "Brake, Parkin",
  "Brake, Service",
  "Clutch",
  "Coupling Devices",
  "Defroster/Heater",
  "Drive Line",
  "Engine",
  "Exhaust",
  "Fifth Wheel",
  "Fluid Levels",
  "Frame and Assembly",
  "Front Axle",
  "Fuel Tanks",
  "Horn",
  "Ligths",
  "Mirrors",
  "Muffler",
  "Oil Pressure",
  "Radiator",
  "Reader End",
  "Reflector",
  "Safety Equipment",
  "Starter",
  "Steering",
  "Suspension System",
  "Tire Chains",
  "Tires",
  "Transmission",
  "Trip Recorder",
  "Wheels and Rims",
  "Windows",
  "Windshield Wipers",
  "Other",
  "Brake Connections",
  "Brakes",
  "Coupling Devices",
  "Coupling (King) Pin",
  "Doors",
  "Hitch",
  "Landing Gear",
  "Lights - All",
  "Reflectors/Refiective Tape",
  "Roof",
  "Suspension System",
  "Tarpaulin",
  "Tires",
  "Wheels and Rims",
  "Truck Items",
  "Trailers Items",
  "Condition of the avobe vehicle is satisfactory",
  "Windshield fluid",
  "Obvious fluid leaks",
  "Belt / Hoses",
  "Left Steer tires, Wheels, Lugs and signs of Oil leakage",
  "Right Steer tires, Wheels, Lugs and signs of Oil leakage",
  "Left Headlights",
  "Right Headlights",
  "Left Turn signals",
  "Right Trun signals",
  "Left Marker lights",
  "Right Marker lights",
  "Fith wheel",
  "King pin",
  "Air / Electricl lines / Gladhands",
  "Coupling Left Marker lights",
  "Coupling Rigth Marker lights",
  "Left Tracktor tires, Wheels",
  "Rigth Tracktor tires, Wheels",
  "Left Mudlaps / Reflective tape",
  "Rigth Mudlaps / Reflective tape",
  "Defroster / Heater / AC",
  "Steering",
  "Parking brake",
  "Service brakes / ABS light (ST only)",
  "Emergency equipment",
  "Left Windshield / Wipers",
  "Rigth Windshield / Wipers",
  "Left Mirros",
  "Rigth Mirros",
  "Engine coolant reservoir",
  "ABS light",
  "Left Marker lights / Reflective tape",
  "Rigth Marker lights / Reflective tape",
  "Left Tires, Wheels, Mudflaps",
  "Rigth Tires, Wheels, Mudflaps",
  "Relective tape",
  "Doors work and latch properly",
  "Liftgate operational",
  "Left Lights",
  "Right Lights",
  "Cancel",
  "Confirm",
  "Form Inspection",
  "Truck",
  "is Out Of Service",
  "is Back In Service"
];
const spanish = [
  "Clave",
  "Entrar",
  "Correo",
  "No se encuentra conectado a ninguna red",
  "Campos Requeridos",
  "Credenciales no válidas",
  "Error sesión múltiple",
  "Error desconocido",
  "Se ha detectado múltiples sesiones abiertas",
  "Se requiere su firma para continuar. Por favor firme dentro del recuadro!",
  "Firma Requerida",
  "Guardar",
  "Limpiar",
  "La firma fue rechazada por el administrador. Por favor ingrese su firma nuevamente.",
  "La firma está en proceso de validación. inténtelo mas tarde.",
  "Fecha Inspección",
  "Hora Inspección",
  "Odómetro",
  "Observaciones",
  "Fecha Inspección Requerida",
  "Hora Inspección Requerida",
  "Odómetro requerido",
  "Número de camión requerido",
  "Número de tráiler requerido",
  "Por favor seleccione un mecánico",
  "Error seleccione una opción",
  "Viaje",
  "Tonelaje",
  "Hora entrada",
  "Hora salida",
  "Subir Ticket",
  "No tiene viajes",
  "Primero debe entrar el horario!",
  "Advertencia",
  "¿Informar un destino incorrecto?",
  "Ver Ticket",
  "Ingrese un Millaje igual o mayor al ingreso",
  "Salida",
  "Ticket invalido, no cumple con las reglas",
  "Ticket: Solo se permiten caracteres en mayúscula numeros y guión",
  "Tons: Solo se permiten números enteros o números con dos decimales",
  "Tons: Tiene que ser mayor que 0",
  "Error",
  "Tons: Debe de ser menor o igual a 40",
  "Compresor de aire",
  "Lineas de aire",
  "Bateria",
  "Correas y mangueras",
  "Carroceria",
  "Frenos, Acesorios",
  "Frenos, Servicio",
  "Frenos, Servicio",
  "Cloche",
  "Dispositivos de acople",
  "Descongelacion / Calentador",
  "Linea de manejo",
  "Motor",
  "Escape",
  "Quinta Rueda",
  "Nivel de fluidos",
  "Chassis",
  "Eje frontal",
  "Tanque de combustible",
  "Claxon",
  "Luces",
  "Espejos",
  "Muffler",
  "Presion aceite",
  "Radiador",
  "Terminal trasero",
  "Reflectores",
  "Equipo de seguridad",
  "Motor de arranque",
  "Direccion",
  "Suspension",
  "Cadenas para gomas",
  "Gomas",
  "Transmision",
  "Odómetro",
  "Llantas y ruedas",
  "Ventanas",
  "Limpia parabrisas",
  "Otros",
  "Frenos y conexiones",
  "Frenos",
  "Dispositivos de acople",
  "Pin de acople (king pin)",
  "Puertas",
  "Enganche",
  "Patas del trailer (landing gear)",
  "Luces - todas",
  "Reflectores y cinta reflectiva",
  "Techo",
  "Sistema de suspension",
  "Lona",
  "Gomas",
  "Llantas y rines",
  "Problemas del Camion",
  "Problemas del Trailer",
  "La condiciones del vehiculo encima es satisfactoria",
  "Fluido limpiaparabrisas",
  "Salideros de liquidos",
  "Correas/Mangueras",
  "Goma direcc Izq / LLantas/Salidero de aceite",
  "Goma direcc Derecha/ LLantas/ Salidero de aceite",
  "Luz de Carretera Izquierda",
  "Luz de Carretera Derecha",
  "Luces de giro Izquierdas",
  "Luces de giro Derechas",
  "Luces de posicion Izquierdas",
  "Luces de posicion Derechas",
  "Quinta Rueda",
  "King pin",
  "Aire/Lineas electricas/Sellos de Aire Trailer",
  "Acoplamiento de las luces de posición izquierda",
  "Acoplamiento de las luces de posición derecha",
  "Gomas traccion Izquierdas",
  "Gomas traccion Derechas",
  "Mudflap Izquierdo / Cinta reflective",
  "Mudflap Derecho / Cinta reflective",
  "AC / Calentador / Descongelador",
  "Direccion",
  "Freno de Parqueo",
  "Freno de servicio / ABS luz",
  "Equipo de emergencia",
  "Limpiaparabrisa Izquierdo",
  "Limpiaparabrisa derecho",
  "Espejos Izquierdos",
  "Espejos derechos",
  "Depósito de refrigerante del motor",
  "Luz de ABS",
  "Luces de posicion Izquierdas / Cinta reflect",
  "Luces de posicion Derechas / Cinta reflect",
  "Gomas Izquierdas, llantas, mudflaps",
  "Gomas Derechas, llantas, mudflaps",
  "Cinta reflect",
  "Puertas y seguros",
  "Puerta trasera operativa",
  "Luces Izquierdas",
  "Luces Derechas",
  "Cancelar",
  "Confirmar",
  "Inspección de formularios",
  "Camion",
  "está fuera de servicio",
  "está de vuelta en servicio"
];

export const text = (palabra) => {
  var resultado = palabra;
  if (english.length > 0) {
    var index = null;
    for (var i in english) {
      if (english[i] === palabra) {
        index = i;
        break;
      }
    }
    if (localStorage.getItem("language") === "es" && index !== null)
      resultado = spanish[index];
  }
  return resultado;
};
